/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ROUTES = {
  index: "/",
  customers: {
    index: "/customers",
    details: "/customers/:customerId",
    info: "/customers/:customerId/info",
    services: "/customers/:customerId/services",
    products: "/customers/:customerId/products",
    contracts: "/customers/:customerId/contracts",
    team: "/customers/:customerId/team",
    applications: "/customers/:customerId/applications",
    applicationDetails: "/customers/:customerId/applications/:applicationId",
    runbook: "/customers/:customerId/applications/:applicationId/runbook",
    environment: "/customers/:customerId/:application/:environmentId",
    assignmentRules: "/customers/:customerId/assignment-rules",
    assignmentRuleDetails:
      "/customers/:customerId/assignment-rules/:assignmentRuleId",
    billingRules: "/customers/:customerId/billing-rules",
    contacts: "/customers/:customerId/contacts",
    comments: "/customers/:customerId/comments",
    tools: "/customers/:customerId/tools",
  },
  services: {
    index: "/services",
    details: "/services/:serviceId",
    offerings: "/service-offerings",
  },
  serviceCommitments: {
    add: "/service-catalog/add",
    index: "/service-catalog",
    details: "/service-catalog/:serviceId",
  },
  productCatalog: {
    index: "/product-catalog",
    details: "/product-catalog/:productId",
  },
  serviceGroups: {
    add: "/service-groups/add",
    index: "/service-groups",
    details: "/service-groups/:serviceGroupId",
  },
  requestCatalog: {
    index: "/request-catalog",
    details: "/request-catalog/:requestId",
  },
  tool: {
    index: "/tool",
    details: "/tool/:toolId",
  },
  reporting: {
    index: "/reporting",
  },
  globalSettings: "/global-settings",
  employees: {
    index: "/employees",
    details: "/employees/:employeeId",
  },
  bulkUpdate: "/bulk-update",
  bulkUpdateResult: "/bulk-update/:updateId",
  maintenance: "/maintenance",
  docs: "/docs",
  audit: "/audit",
};
